import { CommonModule } from '@angular/common';
import { defaultApiConfiguration, baseUrl } from '@kissmybutton/nsx-ui-common-lib';
import { Injectable, NgModule } from '@angular/core';
import { HttpClient, HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { timer } from 'rxjs';

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var TokenInterceptor = /** @class */ (function () {
    function TokenInterceptor() {
    }
    /**
     * @param {?} request
     * @param {?} next
     * @return {?}
     */
    TokenInterceptor.prototype.intercept = /**
     * @param {?} request
     * @param {?} next
     * @return {?}
     */
    function (request, next) {
        // //Each request might have its own token. If not then fallback to the default one;
        // const token = request.headers.has('token') ? request.headers.get('token') : authToken;
        // request.headers.set('Cache-Control', 'no-cache')
        // request = request.clone({
        //   setHeaders: {
        //     Authorization: `Bearer ${token}`
        //   }
        // });
        return next.handle(request);
    };
    TokenInterceptor.decorators = [
        { type: Injectable }
    ];
    /** @nocollapse */
    TokenInterceptor.ctorParameters = function () { return []; };
    return TokenInterceptor;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var ApiResolverService = /** @class */ (function () {
    function ApiResolverService(httpClient) {
        this.httpClient = httpClient;
        this._apiConfiguration = defaultApiConfiguration;
        this._baseUrl = baseUrl;
    }
    Object.defineProperty(ApiResolverService.prototype, "apiConfiguration", {
        get: /**
         * @return {?}
         */
        function () {
            if (!this._apiConfiguration) {
                throw new Error('api-configuration is not defined');
            }
            return this._apiConfiguration;
        },
        set: /**
         * @param {?} configuration
         * @return {?}
         */
        function (configuration) {
            if (this._apiConfiguration) {
                console.log('api-configuration replaced');
            }
            this._apiConfiguration = configuration;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Fetches data for the provided component and for the given type every @param pollingInterval ms.
     * Uses @method resolveDataFrom underneath.
     * @param componentSelector The component selector to fetch data for
     * @param type Endpoint type to send request to
     * @param pollingInterval Polling interval
     */
    /**
     * Fetches data for the provided component and for the given type every \@param pollingInterval ms.
     * Uses \@method resolveDataFrom underneath.
     * @param {?} componentSelector The component selector to fetch data for
     * @param {?} type Endpoint type to send request to
     * @param {?} pollingInterval Polling interval
     * @return {?}
     */
    ApiResolverService.prototype.watchResource = /**
     * Fetches data for the provided component and for the given type every \@param pollingInterval ms.
     * Uses \@method resolveDataFrom underneath.
     * @param {?} componentSelector The component selector to fetch data for
     * @param {?} type Endpoint type to send request to
     * @param {?} pollingInterval Polling interval
     * @return {?}
     */
    function (componentSelector, type, pollingInterval) {
        return timer(0, pollingInterval || 1000)
            .pipe(
        // switchMap(() => {
        //     return this.resolveDataFrom(componentSelector,type)
        // })
        );
    };
    /**
     * Resolves settings for the provided component (e.g topN component) and for the given type.
     * @param componentSelector The component selector to fetch data for
     * @param type Endpoint type to send request to
     */
    /**
     * Resolves settings for the provided component (e.g topN component) and for the given type.
     * @param {?} componentSelector The component selector to fetch data for
     * @param {?} type Endpoint type to send request to
     * @return {?}
     */
    ApiResolverService.prototype.resolveApiSettingsFor = /**
     * Resolves settings for the provided component (e.g topN component) and for the given type.
     * @param {?} componentSelector The component selector to fetch data for
     * @param {?} type Endpoint type to send request to
     * @return {?}
     */
    function (componentSelector, type) {
        if (!this._apiConfiguration[componentSelector]) {
            throw new Error("api-configuration was not found for selector " + componentSelector);
        }
        if (!this._apiConfiguration[componentSelector][type]) {
            throw new Error("api-configuration type was found for type " + type);
        }
        return this._apiConfiguration[componentSelector][type];
    };
    /**
     * @param {?} url
     * @return {?}
     */
    ApiResolverService.prototype.httpGet = /**
     * @param {?} url
     * @return {?}
     */
    function (url) {
        return this.httpClient.get(url);
    };
    ApiResolverService.decorators = [
        { type: Injectable }
    ];
    /** @nocollapse */
    ApiResolverService.ctorParameters = function () { return [
        { type: HttpClient }
    ]; };
    return ApiResolverService;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var ApiResolverModule = /** @class */ (function () {
    function ApiResolverModule() {
    }
    ApiResolverModule.decorators = [
        { type: NgModule, args: [{
                    declarations: [],
                    imports: [
                        CommonModule,
                        HttpClientModule
                    ],
                    providers: [
                        ApiResolverService,
                        {
                            provide: HTTP_INTERCEPTORS,
                            useClass: TokenInterceptor,
                            multi: true
                        }
                    ]
                },] }
    ];
    return ApiResolverModule;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

export { TokenInterceptor, ApiResolverModule, ApiResolverService };

//# sourceMappingURL=kissmybutton-nsx-ui-api-lib.js.map